/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { Route, Switch } from 'react-router';
// material
import { Division, Body, Logo, Link } from '@insticator/insticator-ui'; // iui-material
// pages
import CompleteSignUp from 'pages/auth/completesignup/completesignup_container';
import SignUpComplete from 'pages/auth/signupcomplete/signupcomplete_container';
import SignIn from 'pages/auth/signin/signin_container';
import AcceptAgreement from 'pages/auth/acceptagreement/acceptagreement_container';
import ResetPassword from 'pages/auth/resetpassword/resetpassword_container';
import PasswordReset from 'pages/auth/passwordreset/passwordreset_container';
import PasswordUpdated from 'pages/auth/passwordupdated/passwordupdated_container';
import CompletePasswordReset from 'pages/auth/completepasswordreset/completepasswordreset_container';
import ExpiredLinkPage from 'pages/auth/expiredlink/expiredlink_container';
import NewInvitationSent from 'pages/auth/newinvitationsent/newinvitationsent_container';
// utils
import { url } from 'utils/urls';
import { PrivateRoute } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/auth/auth_styles';



/* ========== ~~~~~~~~~~ AUTH ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) => (
    <Division name={`auth`} klass={`${props.classes.auth}`}>
        <header>
            <Link type={`external`} action={`${url.company}`}><Logo name={`insticator`} text={`Insticator`} /></Link>
        </header>
        <Body>
            <Switch>
                {/*Routes to subsections*/}
                <PrivateRoute permitted={props.showSetPassword} path='/auth/completesignup' component={CompleteSignUp} />
                <Route path='/auth/signupcomplete' component={SignUpComplete} />
                <PrivateRoute permitted={!!props.tokenData.userUUID} path='/auth/expiredlink' component={ExpiredLinkPage} />
                <PrivateRoute permitted={!!props.tokenData.userUUID} path='/auth/newinvitationsent' component={NewInvitationSent} />
                <PrivateRoute permitted={!props.isSignedIn} path='/auth/signin' redirectTo={'/'} component={SignIn} />
                <PrivateRoute permitted={props.showTermsAndConditions} path='/auth/acceptagreement' component={AcceptAgreement} />
                <PrivateRoute permitted={!props.isSignedIn} path='/auth/resetpassword' component={ResetPassword} />
                <PrivateRoute permitted={!props.isSignedIn} path='/auth/passwordreset' component={PasswordReset} />
                <PrivateRoute permitted={!props.isSignedIn} path='/auth/passwordupdated' component={PasswordUpdated} />
                <PrivateRoute permitted={!props.isSignedIn} path='/auth/completepasswordreset' component={CompletePasswordReset} />
            </Switch>
        </Body>
    </Division>
));
